import { render } from "./FolderContainerFlickr.vue?vue&type=template&id=2d791470&scoped=true"
import script from "./FolderContainerFlickr.vue?vue&type=script&lang=js"
export * from "./FolderContainerFlickr.vue?vue&type=script&lang=js"

import "./FolderContainerFlickr.vue?vue&type=style&index=0&id=2d791470&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d791470"]])

export default __exports__